import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, X2CImportValidationError } from '../../../../common/types';

export type SetMappingStateValidationErrorAction = (
	validationError: X2CImportValidationError,
) => Action<State, void, void>;

export const setMappingStateValidationError =
	(validationError: X2CImportValidationError) =>
	({ setState, getState }: StoreActionApi<State>) => {
		const state = getState();
		if (!state.mappingState) {
			return;
		}

		setState({
			mappingState: {
				...state.mappingState,
				validationError,
				errorsFilter: Object.keys(validationError.columnErrors),
			},
		});
	};
